<script>
import playerTools from '@/tools/sketchfab/player'
import textureTools from '@/tools/sketchfab/textures'
import materialTools from '@/tools/sketchfab/materials'
import sceneTools from '@/tools/sketchfab/scene'
import configure from '@/tools/configurator/configure'
import init from '@/tools/configurator/init'
import sensarProjectTools from '@/tools/project/sensar'
import splash from 'Components/splash'
import nowebgl from 'Components/nowebgl'
import annotationoverlay from '../annotation-overlay'
import store from 'Store'


export default {
  name: 'playerSketchfab',
  props: {
    sceneuid: String
  },
  components: {
    annotationoverlay,
    splash,
    nowebgl
  },
  data: function () {
    return {
      cameraMoves: false
    }
  },  

  computed: {
    loaded () {
      return this.$store.getters['scenes/getsceneLoaded']
      // return true
    },
    hasWebgl () {
      return this.$store.state.ui.hasWebgl
    },
    ui () {
      return this.$store.getters['ui/getState']
    },    
    myStyle () {
      const pointer = this.ui.navigatebyannotationonly ? 'none' : 'all'

       return {
        'pointer-events': pointer
      }     
    }
  },
  mounted () {
    // playerTools.init('player__iframe')
    this.loadScene(this.sceneuid)
  },
  methods: {
    loadScene (sceneuid) {
      store.dispatch('scenes/setSceneLoading')
      // store.commit('model/setProperty', {property: 'menuVisible', value: false})
      const self = this
      const playerSettings = store.getters['player/getPayload']
      playerTools.init('player__iframe')
      playerTools.loadScene(sceneuid, playerSettings).then(api => {
        this.initViewer(this)

        api.addEventListener('click', function (info) {
          if (self.modelClickEvent) {
            self.modelClickEvent(info)
          }
        }, { pick: 'fast' })
        api.addEventListener('camerastart', function () {
          if (self.cameraStartEvent) {
            self.cameraStartEvent()
          }
        })
        api.addEventListener('camerastop', function () {
          if (self.cameraStopEvent) {
            self.cameraStopEvent()
          }
        })
      }).catch(error => {
        console.log(error)
        this.catchNoWebgl(this)
      })
    },

    async initViewer (scope) {
      await scope.initTextures()
      await scope.initDisplayItems()
      scope.setScene()

      console.log('STARTING PROMISES')
      let promises = []
      if (store.state.sensar.all.length > 0) {
        //load the sensar deformation textures
        store.state.sensar.all.forEach(sensarItem => {
          sensarItem.deformation.forEach(deformationObject => {
            promises.push(sensarProjectTools.AddTexture(sensarItem, deformationObject).then())
          })
        })
      }
      console.log('promises[0]', promises[0])
      Promise.all(promises).then(values => {
        // open the sidebar
        console.log('SCENE LOADED')
        store.dispatch('scenes/setSceneLoaded')
        store.dispatch('ui/openDrawer')

      
      })
    },
    catchNoWebgl (scope) {
        console.log('User-agent header sent: ',navigator.userAgent)
        store.commit('ui/setHasWebgl', false)
    },
    setScene () {
      configure.SetPostProcessing()
      // configure.SetEnvironment()
      configure.SetLighting()
      configure.SetBackground()
    },    
    modelClickEvent (info) {
      console.log('Mouseclick', info)
    },
    cameraStartEvent () {
      this.cameraMoves = true
    },
    cameraStopEvent () {
      this.cameraMoves = false
    },
    async initTextures () {
      await textureTools.storeTextureList()
    },
    async initDisplayItems () {
      await sceneTools.storeSceneGraph()
      await this.initMaterialItems()
      init.initVisibility()
      init.initEnvironment()
      const currentScene = this.$store.getters['scenes/getCurrentScene']
      init.initViews(currentScene.view)
      console.log('DISPLAY ITEMS READY')
    },
    async initMaterialItems () {
      await materialTools.storeMaterialList()
      await init.initMaterials()
      
    }        
  }  
}
</script>

<template>
  <v-container class="fill-height" fluid>
    <!-- <splash/> -->
    <splash v-if="!loaded && hasWebgl"/>
    <!-- <nowebgl/> -->
    <nowebgl v-if="!hasWebgl"/>
    <annotationoverlay v-if="loaded" :cameraMoves="cameraMoves"/>
    <iframe 
      class="player" 
      :class="{'iframe__hidden': (!loaded)}" 
      id="player__iframe" 
      :style="myStyle">
    </iframe>
  </v-container>
</template>

<style lang="scss" scoped>

.fill-height {
  padding:0px;
}
.iframe {
  height:100%;
  width: 100%;
  position: relative;

}
.player {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  border: 0;
  // opacity: 1;
  transition: opacity 2.0s ease;
  // background: #ddd;
  position: relative;
  z-index:2;

  &.iframe__hidden {
    opacity: 0;
  }
}

</style>
